import {isOfflinePlat, isBaiduApp, addPvNew} from '../../utils';

export default {
    namespaced: true,

    state: {
        // 业务JS初始化逻辑开始时间
        JSInit_starttime: null,
        jsLoad_cost: null,
        JSInit_cost: null,
        JSInit_endtime: null,
        dataLoad_endtime: null,
        dataLoad_cost: null,
        buryReport: false
    },

    getters: {
        JSInit_starttime: state => state.JSInit_starttime,
        jsLoad_cost: state => state.jsLoad_cost,
        JSInit_cost: state => state.JSInit_cost,
        JSInit_endtime: state => state.JSInit_endtime,
        dataLoad_endtime: state => state.dataLoad_endtime,
        dataLoad_cost: state => state.dataLoad_cost,
        buryReport: state => state.buryReport
    },

    mutations: {
        setJSInitStartTime(state, time) {
            state.JSInit_starttime = time;
        },
        setJsLoadCost(state, time) {
            state.jsLoad_cost = time;
        },
        setJSInit_cost(state, time) {
            state.JSInit_cost = time;
        },
        setJSInitEndTime(state, time) {
            state.JSInit_endtime = time;
        },
        setDataLoadEndTime(state, time) {
            state.dataLoad_endtime = time;
        },
        setDataLoadCost(state, time) {
            state.dataLoad_cost = time;
        },
        setBuryReport(state, flag) {
            state.buryReport = flag;
        }
    },

    actions: {
        sendFirstScreenCostBury({commit, state, rootState}, endTime = '', noImg = false, isPreLoad = false) {
            if (state.buryReport) {
                return;
            }
            commit('setBuryReport', true);
            // 首屏埋点
            const renderTime = endTime - state.JSInit_starttime;
            const {dataList = []} = rootState.dataList;
            if (dataList.length === 0) {
                return;
            }
            const data = dataList[0];
            const {unique_id = '', tpSource = ''} = data || {};
            let param = {
                // h5页面资源加载开始时间
                h5_pageInit_starttime: window.pageInit_starttime,
                // 业务JS初始化逻辑开始时间
                JSInit_starttime: state.JSInit_starttime,
                jsLoad_cost: state.jsLoad_cost,
                // 业务JS初始化逻辑执行耗时
                JSInit_cost: state.JSInit_cost,
                JSInit_endtime: state.JSInit_endtime,
                // 接口响应耗时
                dataLoad_cost: state.dataLoad_cost,
                // 首屏服务返回时间
                dataLoad_endtime: state.dataLoad_endtime,
                // 卡片渲染耗时
                firstScreenRender_cost: renderTime,
                // 卡片渲染结束时间
                firstScreenRender_endtime: endTime,
                // 首屏渲染耗时
                firstScreen_cost: endTime - window.pageInit_starttime,
                isPreLoad: isPreLoad,
                uniqueid: unique_id,
                source: rootState.url.source,
                // 是否是评论转笔记
                isComment: rootState.url.dataType === 'poicomment',
                tp: tpSource,
                isNative: isBaiduApp(),
                sv: rootState.url.urlParams?.sv || '',
                isOffline: isOfflinePlat ? 1 : 0,
                comVersion: rootState.url.comVersion
            };
            const jump_time_stamp = rootState.url.jump_time_stamp;
            if (jump_time_stamp > 0) {
                // 首屏渲染耗时包含webview加载完成时间
                param.firstScreen_cost_webview = endTime - jump_time_stamp;
                // openapi点击到webjs开始渲染时间
                param.web_prepare_cost = window.pageInit_starttime - jump_time_stamp;
            }
            if (!noImg) {
                // 图片渲染耗时
                param.microImgRender_cost = renderTime;
                // 首个图片渲染结束
                param.microImgRender_endtime = endTime;
            }
            addPvNew(['MCDfeed.feedtime.pt'], param);
        }
    }
};